import api from '@/utils/api'

export default {
    getPagesBySportId(sportId, page = 1, size = 0) {
        const params = [`page=${page}`, `per_page=${size}`]

        if (sportId !== undefined && sportId !== null && sportId !== '') {
            params.push(`sportId=${sportId}`)
        }

        return api.get(`page/?${params.join('&')}`)
    }
}
